module.exports = __webpack_public_path__ + "img/tn.ce78613a.svg";